import { render, staticRenderFns } from "./UploadSurveys.vue?vue&type=template&id=271bfc0e&"
import script from "./UploadSurveys.vue?vue&type=script&lang=js&"
export * from "./UploadSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports